// extracted by mini-css-extract-plugin
var _1 = "SharingDropdownAddSelect-module__animateUploadProgressBarWidth--pmgCb";
var _2 = "SharingDropdownAddSelect-module__animatedBackground--SLHF5";
var _3 = "SharingDropdownAddSelect-module__categorizedSelect--oF506";
var _4 = "SharingDropdownAddSelect-module__select--e3vxc";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "categorizedSelect", _4 as "select" }
